import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import { Link } from '../../components'
import Styles from './FooterPartner.css'

@CSSModules(Styles)
export default class FooterPartner extends Component {
  constructor(props){
    super(props)
  }
  render() {
    const foeLogo = require( '../../../static/images/img-foe-logo.png' )
    
    return (
      <div styleName='logo-second-wrap'>
        <Link
          to={config.links.friends}
          title='Friends of the Earth'>
          <img
            styleName={'logo-foe'}
            src={foeLogo}
            alt='Friends of the Earth'
          />
        </Link>
        <div styleName='footer-donate-tagline'>
          Friends of the Earth U.S.
        </div>
        <div styleName='footer-social-icons-item'>
          <Link
            to={config.links.socialFoefb}
            title='Friends of the Earth Facebook'>
            <i styleName='footer-social-icon' className='fa fa-facebook-official'/>
          </Link>
          <Link
            to={config.links.socialFoetwitter}
            title='Friends of the Earth Twitter'>
            <i styleName='footer-social-icon' className='fa fa-twitter'/>
          </Link>
          { /* <Link
            to={config.links.socialFoeinstagram}
            title='Friends of the Earth Instagram'>
            <i styleName='footer-social-icon' className='fa fa-instagram'/>
          </Link> */ }
        </div>
      </div>
    )
  }
}
